import axios from 'axios'

let biserver_tpml = `${process.env.PROTOCOL}://${process.env.API_BISERVER}`

// 代理商地址
window.AGENT_SITE = `${process.env.PROTOCOL}://${process.env.AGENT_SITE}`

window.API_BISERVER = biserver_tpml
const http = axios.create({
    headers: {},
    baseURL: biserver_tpml,
    timeout: 10000,
    // withCredentials: true
})

// 添加请求拦截器
http.interceptors.request.use(config => {
    // 在发送请求之前做某事，比如说 设置token
    // config.headers['token'] = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMzA2NjY2ODg4OCIsInVpZCI6Ijg0MDY0MTIwNzA1NTE5NjE2IiwiYXV0aCI6IlNVUEVSX0FETUlOIiwiY29tcGFueUlkIjoiODQwNjQxMjA2NzYxNTk0ODgiLCJleHAiOjMwMTU2Mzg3NDcxMX0.zjhGNYXw-CQh1di8i78V0DDmut5C9RRXm-On0mk8k9jTersTC8kPkX0pTcldr7QLLv27OHN9UFtoT2ldKqI4_A';
    return config;
}, error => {
    // 请求错误时做些事
    return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(response => {
    // 对响应数据做些事
    return response;
}, error => {
    return Promise.reject((error.response && error.response.data) || null); // 返回接口返回的错误信息
})

export default http;


// WEBPACK FOOTER //
// ./src/utils/http/http.js